import { defineComponent as _defineComponent } from 'vue'
import { computed, unref, toRefs } from 'vue';
    import { useOperatorRepository, IOperator } from '@entities/operator';
    import FilterListRender from '@fr/vue/components/filters/common/components/FilterListRender/FilterListRender.vue';
    import useFilterAttributesAnalytics from '@ve/components/filters/common/use/useFilterAttributesAnalytics';
    import FilterPostWrapper from '@fr/vue/components/searchFilters/filterList/desktop/FilterPostWrapper.vue';
    import ToggleListContent from '@fr/vue/components/filters/common/components/toggleListContent/ToggleListContent.vue';
    import FiltersListSection from '@fr/vue/components/searchFilters/filterList/desktop/FiltersListSection.vue';
    import FilterAttributeMethodsOperators from '../lib/FilterAttributeMethodsOperators';
    import useOperatorFilterModel from '../lib/useOperatorFilterModel';

    interface IFilterTourOperatorsProps {
        grouppedFilteredOperators?: IOperator[][],
        grouppedAllOperators?: IOperator[][],
        visibleCounter?: boolean,
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'DesktopFilterOperatorsAccordion',
  props: {
    grouppedFilteredOperators: { default: () => [] },
    grouppedAllOperators: { default: () => [] },
    visibleCounter: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { grouppedFilteredOperators: IOperator[][], grouppedAllOperators: IOperator[][], visibleCounter: boolean }

    

    const { grouppedAllOperators, grouppedFilteredOperators } = toRefs(props);

    const { operators } = useOperatorRepository();

    const { takenOperators } = useOperatorFilterModel();

    const filterAttributesMethodsOperators = computed(() => new FilterAttributeMethodsOperators(unref(operators)));

    const isLeastOneGroupHasTourOperator = computed(() => unref(filterAttributesMethodsOperators)?.isOneEntityHasProperty(unref(grouppedAllOperators)));

    const { toggleAttributeHandler } = useFilterAttributesAnalytics(unref(filterAttributesMethodsOperators), { typeEvent: '', nameAnyEventEng: '', nameAnyEventRu: 'туроператор_Любой' });


return { __sfc: true,props, grouppedAllOperators, grouppedFilteredOperators, operators, takenOperators, filterAttributesMethodsOperators, isLeastOneGroupHasTourOperator, toggleAttributeHandler, FilterListRender, FilterPostWrapper, ToggleListContent, FiltersListSection }
}

})